<template>
  <div class="modal-wrapper" @keyup.esc="$emit('close')">
    <div class="bg-overlay fadeIn animated" @click.prevent.stop="$emit('close')"></div>
    <div class="modal fadeInUp animated" :style="modalStyle">
      <div class="modal__close icon__bg-circle" :style="{'color': closeCrossColor}" @click.stop="$emit('close')">
        <span class="icon-cross2"></span>
      </div>
      <slot name="body">
        <h1>Vil du slette?</h1>
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      closeCrossColor: {
        default: '#ffffff'
      },
      isCloseOnEsc: {
        type: Boolean,
        default: true
      },
      maxWidth: {
        type: String,
        default: null
      },
      top: {
        type: String,
        default: null
      }
    },
    computed: {
      modalStyle () {
        const style = {}
        if (this.maxWidth) style.maxWidth = this.maxWidth
        if (this.top) style.top = this.top
        return style
      }
    },
    methods: {
      handleKeydown (event) {
        if (event.key === 'Escape' && this.isCloseOnEsc) {
          this.$emit('close')
        }
      }
    },
    beforeMount () {
      if (!document.querySelector('body').classList.contains('no-scroll')) {
        document.querySelector('body').classList.add('no-scroll')
      }
    },
    mounted () {
      window.addEventListener('keydown', this.handleKeydown)
    },
    beforeDestroy () {
      document.querySelector('body').classList.remove('no-scroll')
      window.removeEventListener('keydown', this.handleKeydown)
    }
  }
</script>

<style scoped>
  .modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9997;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bg-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10000;
    background-color: rgba(98, 103, 109, .2);
    animation-name: fadeIn;
    animation-duration: 1s;
  }

  .modal {
    position: absolute;
    top: 10vh;
    z-index: 10001;
    background: #f6f9fc;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    width: 100%;
    max-width: 550px;
    animation-name: fadeUp;
    animation-duration: 0.25s;
  }

  .modal__close {
    position: absolute;
    z-index: 1000;
    top: 5px;
    right: 5px;
    cursor: pointer;
    color: #ffffff;
  }

  @keyframes fadeUp {
    from {
      transform: scale(0.95);
      opacity: 0.9;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

</style>




// WEBPACK FOOTER //
// Modal.vue?21702d1a